export const GLOBAL_CONSTANTS = Object.freeze({
  DOWNLOAD_EXCEL: 'Download Excel',
  SEARCH: 'Search',
  FIRST_PAGE: 'First page',
  PREVIOUS_PAGE: 'Previous page',
  NEXT_PAGE: 'Next page',
  LAST_PAGE: 'Last page',
  SAVE: 'Save',
  EDIT: 'Edit',
  DELETE: 'Delete',
  REFRESH: 'Refresh',
  DOWNLOAD: 'Download',
  UPLOAD: 'Upload',
  ADD: 'Add',
  COPY: 'Copy',
  SAVE_CHANGES: 'Save Changes',
  EXPORT: 'Export',
  SAVE_ALL_CHANGES: 'Save All Changes',
  EDIT_ALL_FIELDS: 'Edit All Fields',
  CANCEL_EDIT: 'Cancel Edit',
  SELECT_ROWS_ENABLE_DELETE: 'Select rows to enable delete',
  SELECTED_ROW_S: 'selected row(s)',
  ENTITY_TAN_COL_INFO:
    'Required as Unique ID to map all data. Format: AAAA99999A',
  VENDOR_PAN_COL_INFO:
    'Required for TDS computation. Format: AAAAA9999A. Auto-populates Vendor Status.',
  VENDOR_NAME_COL_INFO:
    'Required in TDS return. No caret character (^) allowed.',
  VENDOR_STATUS_COL_INFO:
    'Auto-populated based on PAN 4th character. C = Company, Others = Other than company',
  RESIDENTIAL_STATUS_COL_INFO:
    'For Form 26Q/27Q bifurcation. Default: R (Resident)',
  TIN_COL_INFO:
    'Tax ID for non-residents. Exactly 20 characters, no caret (^) allowed.',
  OPTING_TAX_REGIME_COL_INFO:
    'Required field in TDS return. Yes/No. In case of "No Input", default value should be "No"',
  ADDRESS_COL_INFO:
    'Required for Vendor Type being "NR". All special characters are allowed except caret character (^)',
  COUNTRY_COL_INFO: 'Required for Vendor Type being "NR"',
  EMAIL_COL_INFO:
    'Required in TDS return. Mandatory if Responsible person\'s email is not provided. Required for Vendor Type being "NR". Both @ and . (dot) should be present in email id. There should be at least 2 alphabets after dot eg: test.test@abc.cc',
  BASIC_EMAIL_VALIDATION_REGEX:
    '^[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]+(\\.[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]+)*@[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]+(\\.[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]+)*\\.[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]{2,}$',
  LINKED_USER_COL_INFO:
    'Users linked to multiple email IDs or marked as inactive will not appear in the dropdown. Please raise a JIRA ticket to remove any additional email IDs.',
  PROVISION_ADVANCE_HEADING: 'Provision & Advance knock off',
  PROVISIONS: 'Provisions',
  ADVANCES: 'Advances',
  FULL_SCREEN_TOOLTIP: 'Full Screen',
  EXIT_FULL_SCREEN_TOOLTIP: 'Exit Full Screen',
  DOWNLOAD_ORIGINAL_FILE: 'Download Original File',
  DOWNLOAD_ERROR_FILE: 'Download Error File',
  MAX_TOTAL_SIZE_MB: 50,
  INACTIVITY_LIMIT: 15 * 60 * 1000,
  // Form version constants (PNW-942)
  NEW_FORM_FY_START: '2026-27',
  FORM_TYPE_140: '140',
  FORM_TYPE_144: '144',
  FORM_TYPE_26Q: '26Q',
  FORM_TYPE_27Q: '27Q',
  RETURNS_UNALLOCATED_CHALLAN_WARNING:
    'Few transaction has not yet allocated. Please check on prepare page.',
  COMPLIANCE_MASTER_FILE_DATA_TYPE: 'Compliance Master'
})
